import { createReducer, on } from '@ngrx/store';
import { clearOrganisationId, clearUIContext, setOrganisationId, setUIContext } from './organisation.actions';

export interface OrganisationState {
  organisation_id: string|null;
  uiContext: {
    currentFlow: 'standalone' | 'overview-popup' | null;
  };
}

export const initialOrganisationState: OrganisationState = {
  organisation_id: '',
  uiContext: {
    currentFlow: null
  }
};

export const organisationReducer = createReducer(
  initialOrganisationState,
  on(setOrganisationId, (state, { organisation_id }) => ({ ...state, organisation_id })),
  on(clearOrganisationId, (state) => ({
    ...state,
    organisation_id: null
  })),
  on(setUIContext, (state, { currentFlow }) => ({
    ...state,
    uiContext: { ...state.uiContext, currentFlow }
  })),
  on(clearUIContext, (state) => ({
    ...state,
    uiContext: { currentFlow: null }
  }))
);